'use client'

import { PartnerPayoutScheduleType } from '@/lib/api/common/interfaces/partner.interface'
import { MdPayments } from 'react-icons/md'

interface PayoutScheduleDisplayProps {
    payoutScheduleType?: PartnerPayoutScheduleType | null
    payoutFixedDay?: number | null
    payoutDaysAfterAppointment?: number | null
    title?: string
    className?: string
}

const TYPE_LABELS: Record<PartnerPayoutScheduleType, string> = {
    OPEN: 'Em aberto (sem data definida)',
    FIXED_DAY: 'Dia fixo do mês',
    DAYS_AFTER_APPOINTMENT: 'Dias após a data do agendamento',
}

const BADGE_CLASS: Record<PartnerPayoutScheduleType, string> = {
    OPEN: 'badge-ghost',
    FIXED_DAY: 'badge-info',
    DAYS_AFTER_APPOINTMENT: 'badge-success',
}

export function PayoutScheduleDisplay({
    payoutScheduleType,
    payoutFixedDay,
    payoutDaysAfterAppointment,
    title = 'Repasse de Valores',
    className = '',
}: PayoutScheduleDisplayProps) {
    const type: PartnerPayoutScheduleType = payoutScheduleType || 'OPEN'

    return (
        <div className={`bg-base-100 rounded-xl border border-base-300/50 p-6 ${className}`}>
            <h2 className="text-lg font-semibold text-base-content mb-4 flex items-center gap-2">
                <MdPayments className="text-xl" />
                {title}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <div className="text-xs font-medium text-base-content/60 mb-1">
                        Modelo
                    </div>
                    <div className={`badge ${BADGE_CLASS[type]} badge-lg`}>
                        {TYPE_LABELS[type]}
                    </div>
                </div>

                {type === 'FIXED_DAY' && (
                    <div>
                        <div className="text-xs font-medium text-base-content/60 mb-1">
                            Dia do mês
                        </div>
                        <div className="text-base font-semibold">
                            {payoutFixedDay
                                ? `Dia ${payoutFixedDay} de cada mês`
                                : 'Não definido'}
                        </div>
                    </div>
                )}

                {type === 'DAYS_AFTER_APPOINTMENT' && (
                    <div>
                        <div className="text-xs font-medium text-base-content/60 mb-1">
                            Prazo
                        </div>
                        <div className="text-base font-semibold">
                            {payoutDaysAfterAppointment
                                ? `${payoutDaysAfterAppointment} dia${payoutDaysAfterAppointment === 1 ? '' : 's'} após o agendamento`
                                : 'Não definido'}
                        </div>
                    </div>
                )}

                {type === 'OPEN' && (
                    <div className="md:col-span-1 text-sm text-base-content/60 self-center">
                        Sem data programada para repasse.
                    </div>
                )}
            </div>
        </div>
    )
}
